import { createStore } from 'vuex';

import auth from './auth';
import coreData from './core_data';
import v2 from './v2';

const store = createStore({
  modules: {
    auth,
    coreData,
    v2,
  },
});

export default store;
